
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { CommonButton } from '../../components/buttons';
import { renderTimePicker } from './../../components/reduxFields';
import moment from 'moment';

import React from 'react';
import Dialog from 'material-ui/Dialog';

const validate = (values) => {
  const errors = {};
  let startDateTime = moment(values.recurrenceAppointmentStartTime);
  let endDateTime = moment(values.recurrenceAppointmentEndTime);
  let duration = moment.duration(endDateTime.diff(startDateTime));
  // console.log(startDateTime, endDateTime, duration.asHours());
  if (duration.asHours() <= 0) {
    errors.recurrenceAppointmentEndTime = 'Please enter valid appointment end time';
  }

  return errors;
};

class ChangeAppointmentDateDialog extends React.Component {
  constructor(props) {
    // console.log('appointment date dialog props', props);
    super(props);
    this.onSubmitDateTime = this.onSubmitDateTime.bind(this);
  }

  onSubmitDateTime(formProps) {
    let data = this.props.appointmentObj;   
    data.startDateTime = moment(data.startDateTime).format('YYYY-MM-DD') + 'T' + moment(formProps.recurrenceAppointmentStartTime).format('HH:mm:ss');
    data.endDateTime = moment(data.endDateTime).format('YYYY-MM-DD') + 'T' + moment(formProps.recurrenceAppointmentEndTime).format('HH:mm:ss');
    this.props.handleRecurrenceAppointments(null, 'Change', data);
  }

  render() {
    const { handleSubmit } = this.props;
    const actions = [
      <CommonButton label="Cancel" className="mr-15 grey_btn" onTouchTap={() => this.props.closeDateDialog()}/>,
      <CommonButton type="submit" primary={true} label= "Save" onTouchTap={handleSubmit(this.onSubmitDateTime)}/>,
    ];
    return (
      <div>
        <Dialog
          className="custom_modal"
          title={'Edit Appointment Time'}
          modal={false}
          open={this.props.open}
          actions={actions}
          autoScrollBodyContent={true}
        >
          <div className="row">
            <div className="col-sm-12">
              <form className="readmin-form custom_form">
                <div className="row">
                  <div className="col-sm-6 wd_full">
                    <Field
                      name="recurrenceAppointmentStartTime"
                      placeholder="Start Time"
                      fullWidth={true}
                      selected={this.props.recurrenceAppointmentStartTime}
                      onDateChange={this.props.onDateChange}
                      component={renderTimePicker}

                    />
                  </div>
                  <div className="col-sm-6 wd_full">
                    <Field
                      name="recurrenceAppointmentEndTime"
                      placeholder="End Time"
                      fullWidth={true}
                      selected={this.props.recurrenceAppointmentEndTime}
                      onDateChange={this.props.onDateChange}
                      component={renderTimePicker}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let defaultValues = null;
  if (ownProps.appointmentObj) {    
    defaultValues = {
      recurrenceAppointmentStartTime: moment.utc(ownProps.appointmentObj.startDateTime).format('YYYY-MM-DD') + 'T' + moment.utc(ownProps.appointmentObj.startDateTime).format('HH:mm:ss'),
      recurrenceAppointmentEndTime: moment.utc(ownProps.appointmentObj.endDateTime).format('YYYY-MM-DD') + 'T' + moment.utc(ownProps.appointmentObj.endDateTime).format('HH:mm:ss'),
    };
  }
  //  console.log(defaultValues);
  return {
    initialValues: defaultValues,
  };
};

ChangeAppointmentDateDialog = reduxForm({
  form: 'ChangeAppointmentDateDialog', // a unique identifier for this form
  validate,
  enableReinitialize: true,
})(ChangeAppointmentDateDialog);

export default connect(mapStateToProps, null)(ChangeAppointmentDateDialog);



// WEBPACK FOOTER //
// ./src/modules/scheduling/changeAppointmentDateDialog.js